import React, { useState, useMemo } from 'react';
import { Box, Paper, Tabs, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PageContainer from '../../components/PageContainer/PageContainer';
import ProfileInfoTab from './tabs/ProfileInfoTab';
import ProfileLeavesTab from './tabs/ProfileLeavesTab';
import PersonIcon from '@mui/icons-material/Person';
import EventNoteIcon from '@mui/icons-material/EventNote';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ProfileExpensesTab from './tabs/ProfileExpensesTab';

const tabConfig = [
  {
    value: 'profile',
    labelKey: 'profile.tabs.info',
    defaultLabel: 'Profil Bilgileri',
    icon: <PersonIcon sx={{ mr: 1, mb: '-2px' }} />,
    component: ProfileInfoTab,
  },
  {
    value: 'leaves',
    labelKey: 'profile.tabs.leaves',
    defaultLabel: 'İzinler',
    icon: <EventNoteIcon sx={{ mr: 1, mb: '-2px' }} />,
    component: ProfileLeavesTab,
  },
  {
    value: 'expenses',
    labelKey: 'profile.tabs.expenses',
    defaultLabel: 'Masraflar',
    icon: <ReceiptIcon sx={{ mr: 1, mb: '-2px' }} />,
    component: ProfileExpensesTab,
  },
];

const ProfilePage = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(tabConfig[0].value);


  const activeTabObj = useMemo(
    () => tabConfig.find(tab => tab.value === activeTab),
    [activeTab]
  );

  return (
    <PageContainer currentPage={t('profile.title', 'Profil')}>
      <Box sx={{ py: 4, px: { xs: 1, sm: 3 } }}>
        <Paper elevation={2} sx={{ mb: 3, borderRadius: 3, bgcolor: 'background.paper', p: 1 }}>
          <Tabs
            value={activeTab}
            onChange={(_, val) => setActiveTab(val)}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="profile tabs"
            TabIndicatorProps={{ style: { height: 4, borderRadius: 2 } }}
          >
            {tabConfig.map(tab => (
              <Tab
                key={tab.value}
                value={tab.value}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {tab.icon}
                    <span>{t(tab.labelKey, tab.defaultLabel)}</span>
                  </Box>
                }
                sx={{ minWidth: 140, fontWeight: activeTab === tab.value ? 700 : 400, borderRadius: 2, mx: 0.5 }}
              />
            ))}
          </Tabs>
        </Paper>
        <Box>
          {activeTabObj?.component && <activeTabObj.component />}
        </Box>
      </Box>
    </PageContainer>
  );
};

export default ProfilePage;
